import React from 'react';

import { Spinner } from './Feedback';
import { buttonClassName, type ButtonSize, type ButtonVariant } from './buttonStyles';

interface Props extends React.ComponentPropsWithoutRef<'button'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Mostra spinner, bloqueia clique e marca `aria-busy`. */
  loading?: boolean;
  fullWidth?: boolean;
  /** Formato de pílula (`rounded-full`), para ação compacta de cabeçalho. */
  pill?: boolean;
  /** Quadrado, só com ícone. Exige `aria-label`. */
  iconOnly?: boolean;
}

/**
 * Botão padrão. `type` é `button` por padrão — só submete formulário quem pede
 * `type="submit"` explicitamente.
 */
const Button: React.FC<Props> = ({
  variant = 'primary',
  size = 'md',
  loading = false,
  fullWidth = false,
  pill = false,
  iconOnly = false,
  disabled,
  type = 'button',
  className = '',
  children,
  ...rest
}) => (
  <button
    type={type}
    disabled={disabled || loading}
    aria-busy={loading || undefined}
    className={`${buttonClassName({ variant, size, fullWidth, pill, iconOnly })} ${className}`}
    {...rest}
  >
    {loading && <Spinner />}
    {children}
  </button>
);

export default Button;
